import { DateTime } from 'luxon';

/**
 * Noyau des dates de l'app mobile ET du site web : les instants UTC reçus du back sont toujours
 * affichés à l'heure de Bruxelles, quel que soit le fuseau de l'appareil ou du serveur.
 * La saisie fait le chemin inverse via `LocaleDatetimeToUtcIso`.
 */
export const BRUSSELS_ZONE = 'Europe/Brussels';

/** Instant (ISO UTC ou `Date`) vu à l'heure de Bruxelles. */
export const toBrussels = (value: string | Date): DateTime =>
	(typeof value === 'string' ? DateTime.fromISO(value, { zone: 'utc' }) : DateTime.fromJSDate(value)).setZone(BRUSSELS_ZONE);

/** Maintenant, à l'heure de Bruxelles. */
export const nowBrussels = (): DateTime => DateTime.now().setZone(BRUSSELS_ZONE);

/** Formate un instant à l'heure de Bruxelles avec les mêmes options qu'`Intl.DateTimeFormat`. */
export const formatBrussels = (value: string | Date, locale: string, options: Intl.DateTimeFormatOptions): string =>
	toBrussels(value).setLocale(locale).toLocaleString(options);
